import { useMemo } from "react";
import { isEndpointEditable } from "../utilities/dataSourceAdapters";
import { ApiEndpoint } from "../types";

/**
 * Hook to check if an endpoint is editable
 */
export const useIsEndpointEditable = (endpoint: ApiEndpoint | null): boolean => {
  return useMemo(() => {
    if (!endpoint) return false;
    return isEndpointEditable(endpoint);
  }, [endpoint]);
};
